import { ICreatePackageResponse, PACKAGE_NAME } from '../interface/IPayload';
import { IAboutYouData, IAppProviderState } from '../interface/IAppProvider';

const initialState: IAppProviderState = {
    effectiveDate: undefined,
    salesComplete: false,
    selectedPaymentOption: undefined,
    terminationCompany: undefined,
    terminationRequested: undefined,
    terminationWhen: undefined,
    terms: {
        correctInfo: false,
        factsAndTerms: false,
        stricter: false,
        rki: false
    },
    aboutYouData: { name: '', addr: '', phone: '', email: '' } as IAboutYouData,
    cprNo: '',
    alreadyCovered: { value: false, index: -1 },
    telephone: '',
    selectedPackage: {
        packageName: PACKAGE_NAME.PREMIUM,
        additionalCoverages: [],
        coverages: [],
        quoteId: 0,
        productId: 0
    },
    bankInfo: {
        accNumber: '',
        regNumber: ''
    },
    householdSize: '',
    createPackage: {} as ICreatePackageResponse,
    updatedExtraCoverages: [],
    hasError: { stepOne: false, stepTwo: false },
    hasAgeError: false,
    initialState: true,
    stateChange: false,
    isLoading: false,
    prizeZero: false,
    emailSent: false,
    refreshFromCache: false,
    hasEboksSubscription: false,
    actualStep: 0,
    customerHasMarking: null,
    isValidInsurance: null,
    isBornholm: null,
    giftCard: null
};

export default initialState;
